import {
    getExport
} from "./export"

export async function getSalesAnalysisReport(type, params){
    return getExport(`/export/salesanalysisreport`, type, params);
}
